import { ICountry } from '../../api/RampSdApiSdk';
import { IDropdownOption } from '../domain/entities/Config';

export const STORE_ENTRY_DELIMITER = '\n';
export const STORE_ID_VALUE_DELIMITER = '|';

export const buildCountryCodeDropdown = (countries: ICountry[]): IDropdownOption[] => {
    return countries.map((item) => {
        return {
            label: `+${item.callingCode} ${item.name}`,
            value: item.callingCode
        };
    });
};

export const buildLocationDropdown = (countries: ICountry[]): IDropdownOption[] => {
    return countries.map(({ name, id }) => {
        return {
            label: name,
            value: `${id}`
        };
    });
};

export const buildDropdownOptionsFromArray = (options: string[]): IDropdownOption[] => {
    const list = options.map((option) => ({
        label: option,
        value: option
    }));

    return list;
};

export const buildStoreDropdown = (storeList: string): IDropdownOption[] => {
    const storeEntries = storeList.split(STORE_ENTRY_DELIMITER);

    return storeEntries.map((storeEntry) => {
        const [value, label] = storeEntry.split(STORE_ID_VALUE_DELIMITER);
        if (value && label) {
            return {
                label,
                value
            };
        } else {
            return {
                label: '',
                value: ''
            };
        }
    });
};

export const buildNumericDropdownOptions = (start: number, end: number): IDropdownOption[] => {
    const options = [];
    if (start < end) {
        for (let i = start; i <= end; i++) {
            const val = i.toString();
            options.push(val);
        }
    } else {
        for (let i = start; i >= end; i--) {
            const val = i.toString();
            options.push(val);
        }
    }

    return buildDropdownOptionsFromArray(options);
};
